import { Component, OnInit } from '@angular/core';
import { trigger, style, state, animate, transition} from '@angular/animations';
import { LoginService } from '../../services/login/login.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.css'],
})
export class LoginModalComponent implements OnInit {

  public user: string = "";
  public passwd: string = "";
  public displayLoginError: boolean = false;
  public isLoggedIn: boolean;
  private isLoggedIn$: Subscription;
  private username$: Subscription;

  constructor(
    private loginService: LoginService,
  ) {
    this.isLoggedIn$ = this.loginService.getLoggedInObservable().subscribe(
      newValue => this.isLoggedIn = newValue
    );
    this.username$ = this.loginService.getUserObservable().subscribe(
      newValue => this.user = newValue
    )
  }

  ngOnInit() {
    this.user = this.loginService.getUsername();
    this.isLoggedIn = this.loginService.isLoggedIn();
  }

  ngOnDestroy() {
    this.username$.unsubscribe();
    this.isLoggedIn$.unsubscribe();
  }

  public doLogin() {
    console.log("Trying to authenticate user " + this.user);
    this.loginService.authenticate(this.user, this.passwd)
    .then((success: boolean) => {
      if (! success) {
        this.displayLoginError = true;
        return;
      };
      this.displayLoginError = false;
      this.passwd = "";
    })
    .catch(e => console.log(e));
  }

  public doLogout() {
    this.loginService.logOut();
  }

}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/login-modal/login-modal.component.ts